<template>
  <div>

  	<div v-if="!kit">
  		<!-- user content -->
		<div v-if="content.service_welcome_greeting_guest" class="mb-2" v-html="content.service_welcome_greeting_guest"></div>
		<a href="javascript:void(0)" @click="openLoginWindow()">Starten Sie hier</a>
  	</div>

  	<div v-else>

		<!--<div class="mb-4">
			<h5 class="mb-4">Meine Fahrzeuge</h5> 
			<div class="c1 mb-4">
				<p>Hier sehen Sie eine Übersicht über Ihre Fahrzeuge.</p>
			</div>
		</div>
	  	<div class="spinner-border mr-2" role="status" v-if="loading">
            <span class="sr-only">Loading...</span>
        </div>

        <div class="d-flex align-items-center mw-50" v-if="vehicles.length == 0">
        	Sie haben noch keine Fahrzeuge erfasst.
        </div>
    	-->

		<!--<ul id="vehicles" class="list-unstyled">
			 <li v-for="vehicle in vehicles" class="vehicle">
				<i aria-hidden="true" class="fa fa-car"></i> 
				<strong>{{ vehicle.manufacturer }} {{ vehicle.type }}</strong>
				<div class="vehicle-details">
					<span>Modell: {{ vehicle.model }}</span>
					<span>Kennzeichen: {{ vehicle.licensePlate }}</span>
				</div>
			</li>
		</ul>-->

		<!--<ul id="vehicles" class="list-unstyled" v-if="vehicles.length > 0">
			 <li v-for="vehicle in vehicles" class="vehicle">
				<i aria-hidden="true" class="fa fa-car"></i> 
				<strong>{{ vehicle.brand }} {{ vehicle.model }}</strong>
				<div class="vehicle-details">
					<span>VIN: {{ vehicle.vin }}</span>
					<span>Kennzeichen: {{ vehicle.licenseplate }}</span>
				</div>
				<span @click="deleteVehicle(vehicle.id)" style="font-size:12px;color:red;">Fahrzeug löschen</span>
			</li>
		</ul>

		<hr />-->

		<KSRSelectVehicle @setvehicle="setVehicle" :kit="kit" />

	</div>

	</div>
</template>

<script>
//import KSRNewVehicle from "./KSRNewVehicle";
import KSRSelectVehicle from "./KSRSelectVehicle";

export default {

	components:{ KSRSelectVehicle },
    name: "KSRVehicles",
    data() {
        return {
        	loading: false,
        	vehicles: [],
        	formdata: {
        		licenseplate: '',
        		vin: '',
        		brand: '',
        		model: '',
        		ez: ''
        	},
        	formdata_errors: [],
        	message: '',
        }
    },
    computed: {
    },
 	created() {
 		this.refreshVehicles();
    },
    methods: {

    	onCreateVehicle() {

    		this.message = '';

    		// validation
    		this.formdata_errors = [];
			if(this.formdata.licenseplate == '') {
                this.formdata_errors.push('licenseplate');
            }
            if(this.formdata.brand == '') {
                this.formdata_errors.push('brand');
            }
            if(this.formdata.model == '') {
                this.formdata_errors.push('model');
            }
            if(this.formdata.vin == '') {
                this.formdata_errors.push('vin');
            }

            // validation ok
            if(!this.formdata_errors.length) {

	    		var data = {
	        		formdata: this.formdata
	   			}

	   			var _this = this;

	    		axios.post('/api/ksr/create-vehicle?identityToken='+this.kit, data)
		        .then((response) => {
		        	console.log(response.data.status);
		            //this.vehicles = response.data.value;
		            if(response.data.status == 'exists') {
		            	_this.message = 'Fahrzeug existiert bereits.';
		            }
		            if(response.data.status == 'created') {
		            	_this.message = 'Fahrzeug wurde erfolgreich angelegt.';
		            	_this.vehicles.push(response.data.vehicle);
		            }
		            this.loading = false;
		        });

		    }
    	},
    	deleteVehicle(id) {
    		var _this = this;
    		axios.delete('/api/ksr/delete-vehicle/'+id+'&identityToken='+this.kit)
	        .then((response) => {
	            //this.vehicles = response.data.value;
	            if(response.data.status == 'deleted') {
	            	//_this.message = 'Fahrzeug existiert bereits.';
			        axios.get('/api/ksr/vehicles?identityToken='+this.kit)
			        .then((response) => {
			            _this.vehicles = response.data;
			            _this.loading = false;
			        });
	            }
	            this.loading = false;
	        });
    	},
	    formatLicensePlate() {
            if(!this.formdata.licenseplate.includes('-'))
                this.formdata.licenseplate = this.formdata.licenseplate.replace(/ /g,'-');
            this.formdata.licenseplate = this.formdata.licenseplate.toUpperCase();
        },
        refreshVehicles() {
	 		this.loading = false;
	 		var _this = this;
	        axios.get('/api/ksr/vehicles?identityToken='+this.kit)
	        .then((response) => {
	            _this.vehicles = response.data;
	            _this.loading = false;
	        });
        }
    },
    props: ['kit', 'storeId']
};
</script>

<style>
	.debug {
		border:1px solid #ccc;
		padding:5px;
		font-family:monospace;
		font-size:12px;
		font-weight:bold;
	}
	.debug p {
		margin-bottom:5px;
	}
	.debug p span {
		font-weight:normal;
	}
	.appointment-slot {
		cursor:pointer;
	}
	.appointment-slot:hover {
		border-color:#555;
	}
	.vc-svg-icon[data-v-63f7b5ec] {
	    color: #c1c1c1;
	}
	/*.step-7 .vc-arrows-container {
		display:none !important;
	}*/
</style>